import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'



const initialState = {
  currentSession: null,
  boxes : [],
  currentShopBox: null,
  sellerName: '',
  sellerId: null,
  company: {},
  currency: {}
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
